import React, { useEffect } from 'react'
import { Route, Routes, useNavigate } from 'react-router-dom'
import NotFoundPage from '../pages/error/404'
import {Col, Container, Row} from 'react-bootstrap'
import MenuSchool from '../components/menus/MenuSchool'
import Dashboard from '../pages/school/Dashboard'
import Config from '../pages/school/Config'
import Profile from '../pages/school/Profile'
import jwtDecode from 'jwt-decode'
import { Footer } from '../components/footers/Footer'
import { HeaderSchool } from '../components/headers/HeaderSchool'
import CreateSelection from '../pages/school/CreateSelection'
import Process from '../pages/school/Process'
import EditSelection from '../pages/school/EditSelection'
import PreCandidatesSelection from '../pages/school/PreCandidatesSelection'
import CandidatesSelection from '../pages/school/CandidatesSelection'
import RefusedsSelection from '../pages/school/RefusedsSelection'
import BlockedDatabase from '../pages/school/BlockedDatabase'
import FavouritesDatabase from '../pages/school/FavouritesDatabase'
import GeneralData from '../pages/school/GeneralData'
import RequestsSent from '../pages/school/RequestsSent'
import Tickets from '../pages/candidate/Tickets'
import SchoolStaffs from '../pages/school/SchoolStaffs'
import CandidateData from '../pages/school/CandidatesData'
import Subscription from '../pages/school/Subscription'
import PaymentMethods from '../pages/school/PaymentMethods'

export default function SchoolRouter () {
	const navigate = useNavigate()

	useEffect(() => {
		let token = sessionStorage.getItem('jwt')
		let firsttimeSession = sessionStorage.getItem('firsttime')

		if (token !== 'undefined') {
			let firsttime = jwtDecode(token).firsttime

			if(firsttime === true && firsttimeSession !== 'false'){
				navigate('/school/profile')
			}
		}else{
			navigate('/login')
		}
	}, [navigate])

	return (
		<Container className='d-flex contenedor'>
			<div className='menu-lateral d-none d-lg-block'>
				<MenuSchool/>
			</div>
			<div className='contenido'>
				<Row>
					<Col>
						<HeaderSchool/>
					</Col>
				</Row>
				<Row>
					<Col>
						<Routes>
							<Route path="/dashboard" element={<Dashboard/>}/>
							<Route path="/config" element={<Config/>}/>
							<Route path="/profile" element={<Profile/>}/>
							<Route path="/programprocess" element={<CreateSelection/>}/>
							{/* <Route path="/startprocess" element={<CreateSelection needDate={false} />}/> */}
							<Route path="/editprocess/:id" element={<EditSelection />}/>
							<Route path="/overviewprocess/:id" element={<GeneralData />}/>
							<Route path="/overviewprocess/:id/precandidates" element={<PreCandidatesSelection />}/>
							<Route path="/overviewprocess/:id/candidates" element={<CandidatesSelection />}/>
							<Route path="/overviewprocess/:id/candidates/:choose" element={<CandidateData />}/>
							<Route path="/overviewprocess/:id/refuseds" element={<RefusedsSelection />}/>
							<Route path="/overviewprocess/:id/requestssent" element={<RequestsSent />}/>
							<Route path="/activeprocesses" element={<Process />}/>
							<Route path="/completedprocesses" element={<Process finished={true}/>}/>
							<Route path="/database/blocked" element={<BlockedDatabase />}/>
							<Route path="/database/favourites" element={<FavouritesDatabase />}/>
							<Route path="/staff" element={<SchoolStaffs />}/>
							<Route path="/tickets" element={<Tickets/>}/>
							<Route path="/subscription" element={<Subscription/>}/>
							<Route path="/paymentMethods" element={<PaymentMethods/>}/>
							<Route path="*" element={<NotFoundPage/>}/>
						</Routes>
					</Col>
				</Row>
				<Row>
					<Col>
						<Footer/>
					</Col>
				</Row>
			</div>
		</Container>
    )
}